import { render } from "./HomeView.vue?vue&type=template&id=614d89f0&lang=pug"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__